import { FileX } from 'lucide-react'
import { cn } from '@/lib/utils'

interface DataTableEmptyProps {
  /** Mensaje a mostrar */
  message?: string
  /** Icono personalizado */
  icon?: React.ReactNode
  /** Acción opcional (ej: botón para crear) */
  action?: React.ReactNode
  /** Clases adicionales */
  className?: string
}

/**
 * Estado vacío para DataTable
 */
export function DataTableEmpty({
  message = 'No hay datos para mostrar',
  icon,
  action,
  className,
}: DataTableEmptyProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-md border border-dashed p-8 text-center',
        className
      )}
    >
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-muted">
        {icon || <FileX className="h-6 w-6 text-muted-foreground" />}
      </div>
      <h3 className="mt-4 text-sm font-medium text-foreground">{message}</h3>
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
